import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Button, Col, Grid, OverlayTrigger, Row, Tooltip} from "react-bootstrap";
import moment from "moment";
import * as api from "./QuickbooksCustomersApi";
import {select} from "../../../common/commonHandlers";
import ResourceComponent from "../../../components/ResourceComponent";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faAngleDown,
    faAngleUp,
    faExchangeAlt,
    faInfoCircle,
    faLongArrowAltLeft,
    faLongArrowAltRight,
    faMinusCircle,
    faSync,
    faTimes,
    faTimesCircle
} from '@fortawesome/free-solid-svg-icons'
import Select from "react-select";
import InlineEditable from "../../Scheduler/InlineEditable";
import MDSpinner from "react-md-spinner";
import './QuickbooksCustomers.css';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import SyncAllModal from "../SyncAllModal";
import * as progressActions from "../QuickbooksApi";
import {debounce} from "throttle-debounce";
import ConfirmDisassociateModal from "./ConfirmDisassociateModal";
import {Link} from "react-router";
import ErrorInfoModal from "../ErrorInfoModal";
import MatchedCustomersModal from "../MatchedCustomersModal";
import AddressMismatchModal from "../AddressMismatchModal";
import * as _ from 'lodash';
import classNames from 'classnames';

const actions = {...api, ...progressActions};

class QuickbooksCustomers extends ResourceComponent {

    state = {
        filterVisible: true,
        resource: {
            from: moment().subtract(7, "days").utc().startOf('day'),
            to: moment().utc().endOf('day'),
            customer_id: null,
            showSynchronized: false,
            qb_customer: null,
            page: 1,
            per_page: 25,
            byInvoice: true,
            showNotSyncCustomer: false
        },
        collapsedRows: [],
        content: [],
        rowLoading: null,
        isSearching: false,
        isSearchingQbCustomer: false,
        customerQbOptions: [],
        showDisassociateModal: {
            show: false,
            th_id: null,
            index: null
        },
        editedRow: null,
        refreshingCustomerId: null,
        errorModal: {show: false, error_sites: [], message: ''},
        matchedCustomerModal: {show: false, matched_customers: null, index: null},
        addressMismatchModal: {show: false, mismatches: [], index: null, items: null, isSaving: false, savingMismatchKey: null},
        addressSyncMap: {},
        tableResizeKey: 0
    };

    constructor(props, context) {
        super(props, context);
        this.customerSearch = {
            searchOptions: () => [],
            search: () => {
            }
        };
        this.qbCustomerSearch = {
            searchOptions: () => [],
            search: () => {

            }
        };
    }

    handleWindowResize = debounce(150, () => {
        const {eventKey, selectedKey} = this.props;
        if (eventKey === selectedKey) {
            this.setState(prev => ({tableResizeKey: prev.tableResizeKey + 1}));
        }
    });

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {
            eventKey,
            selectedKey,
            dateTo,
            dateFrom,
            showSynchronized,
            customerFilterType,
            byInvoice,
            showNotSyncCustomer,
            shippingAddressSync
        } = this.props;
        const {resource} = this.state;
        if (dateTo && dateFrom &&
            (prevProps.dateTo !== dateTo ||
                prevProps.dateFrom !== dateFrom ||
                prevProps.showSynchronized !== showSynchronized ||
                prevProps.byInvoice !== byInvoice ||
                prevProps.showNotSyncCustomer !== showNotSyncCustomer ||
                prevProps.shippingAddressSync !== shippingAddressSync
            )) {
            resource["from"] = dateFrom;
            resource["to"] = dateTo;
            resource["showSynchronized"] = showSynchronized;
            resource["byInvoice"] = byInvoice;
            resource["showNotSyncCustomer"] = showNotSyncCustomer;
            resource["shippingAddressSync"] = shippingAddressSync;
            resource["page"] = 1;

            if (eventKey === selectedKey) {
                this.setState({ resource: resource }, this.sync);
            } else {
                this.setState({ resource: resource });
            }
        }
        if (prevState.content !== this.state.content) {
            this.setState({editedRow: null, closeEditRow: true})
        }

        if (prevProps.eventKey !== eventKey || prevProps.selectedKey !== selectedKey) {
            if (eventKey === selectedKey) {
                this.customerSearch = this.buildSearchComponent('customer_id', this.props.actions.searchForCustomer);
                this.qbCustomerSearch = this.buildSearchComponent('qb_customer', e => this.props.actions.searchForQbCustomer(e, (res) => this.setState({
                    customerQbOptions: res,
                    isSearchingQbCustomer: false
                })));
                this.sync();
                this.setState(prev => ({tableResizeKey: prev.tableResizeKey + 1}));
            }
        }
        if (prevProps.customerFilterType !== customerFilterType) {
            resource.page = 1
            this.setState({resource: resource})
        }
    }

    componentDidMount() {
        const {dateTo, dateFrom} = this.props;
        const {resource} = this.state;

        this.customerSearch = this.buildSearchComponent('customer_id', this.props.actions.searchForCustomer);
        this.qbCustomerSearch = this.buildSearchComponent('qb_customer', e => this.props.actions.searchForQbCustomer(e, (res) => this.setState({
            customerQbOptions: res,
            isSearchingQbCustomer: false
        })));
        if (window.location.href.indexOf("customer_id") === -1) {
            if (dateTo && dateFrom) {
                resource["from"] = dateFrom;
                resource["to"] = dateTo;
                this.setState({resource: resource}, this.sync);
            } else {
                this.sync();
            }
        }
        window.addEventListener('resize', this.handleWindowResize);
        this.props.onRef(this)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowResize);
        this.props.onRef(undefined)
    }

    sync = (uniqueCustomer) => {
        const {resource} = this.state;
        const {customerFilterType, customerQbFilter, customerThFilter, page, shippingAddressSync} = this.props
        this.props.setIsLoading && this.props.setIsLoading();
        this.props.actions.syncCustomers({
            ...resource,
            customerFilterType: customerFilterType,
            customerQbFilter: customerQbFilter,
            customerThFilter: customerThFilter,
            page: page ? page : resource.page,
            ...(uniqueCustomer && {
                byInvoice: false,
                showNotSyncCustomer: true,
                showSynchronized: true
            })
        }, response => this.setState({...response, collapsedRows: [], rowLoading: null}, () => {
            if (shippingAddressSync) {
                this.changeShippingAddress();
            } else {
                this.refreshAllAddresses();
            }
            this.props.setIsNotLoading();
        }));
    }

    refreshCustomerRow = (index, items = {}, options = {}) => {
        const {
            side = 'both',
            onComplete = null,
            refreshAddressMap = true,
            thId: thIdOverride = null,
            qbId: qbIdOverride = null
        } = options;

        const {content} = this.state;
        const row = content[index] || items;

        const thId = thIdOverride || row?.th?.id || row?.th?.customer?.id;
        const qbId = qbIdOverride || row?.qb?.quickbooks_id;

        const shouldRefreshTh = side === 'both' || side === 'th';
        const shouldRefreshQb = side === 'both' || side === 'qb';

        let id = null;
        let isThCustomer = false;

        if (shouldRefreshQb && qbId) {
            id = qbId;
            isThCustomer = false;
        } else if (shouldRefreshTh && thId) {
            id = thId;
            isThCustomer = true;
        }

        if (!id) {
            onComplete && onComplete();
            return;
        }

        this.props.actions.getQbCustomer(
            id,
            isThCustomer,
            res => {
                const result = res.content;

                if (content[index]) {
                    this.sortSites(result);
                    this.sortSites(result?.customer);

                    if (isThCustomer) {
                        content[index].th = result;
                        const sameQbId = content[index].qb?.quickbooks_id &&
                            result?.customer?.quickbooks_id &&
                            content[index].qb.quickbooks_id === result.customer.quickbooks_id;

                        if (result?.customer && (_.isEmpty(content[index].qb) || sameQbId)) {
                            content[index].qb = result.customer;
                        }
                    } else {
                        content[index].qb = result;
                        const sameQbId = content[index].th?.quickbooks_id &&
                            result?.customer?.quickbooks_id &&
                            content[index].th.quickbooks_id === result.customer.quickbooks_id;

                        if (result?.customer && (_.isEmpty(content[index].th) || sameQbId)) {
                            content[index].th = result.customer;
                        }
                    }

                    if (refreshAddressMap && content[index].qb && content[index].th) {
                        this.refreshAddress(content[index].qb, content[index].th, index);
                    }

                    this.setState({ content });
                }

                onComplete && onComplete(result);
            },
            () => {
                onComplete && onComplete(null);
            }
        );
    };

    mismatchKey = (mismatch) => `${mismatch?.record_type || ''}:${mismatch?.quickbooks_id || ''}`

    addressMismatchesFrom = (res) => {
        const data = res?.data || res || {};
        const result = [
            ...(data?.address_mismatches || []),
            ...(data.error_sites || []).flatMap(siteError => (siteError?.address_mismatches || []))
        ];

        return _.uniqBy(
            result.filter(Boolean),
            mismatch => this.mismatchKey(mismatch)
        );
    }

    modalizeMismatches = (mismatches) =>
        mismatches
            .map((mismatch, mismatchIndex) => ({
                ...mismatch,
                _modalKey: `${this.mismatchKey(mismatch)}:${mismatchIndex}`
            }));

    loadPreviewAddressMismatches = (mismatch, items = null) => {
        const siteSyncPreferences = _.get(items, 'qb.sites', []).map(site => ({
            quickbooks_id: site.quickbooks_id,
            s_address_sync: site.s_address_sync
        }));

        this.props.actions.previewAddressMismatches(
            {
                quickbooks_id: mismatch.quickbooks_id,
                record_type: mismatch.record_type,
                site_sync_preferences: siteSyncPreferences
            },
            (res) => {
                const previewMismatches = this.addressMismatchesFrom(res);

                this.setState(prevState => {
                    if (!prevState.addressMismatchModal?.show) {
                        return null;
                    }

                    const existingMismatches = prevState.addressMismatchModal.mismatches || [];
                    const combined = _.uniqBy(
                        [
                            ...existingMismatches,
                            ...this.modalizeMismatches(previewMismatches)
                        ],
                        mismatch => this.mismatchKey(mismatch)
                    );

                    return {
                        addressMismatchModal: {
                            ...prevState.addressMismatchModal,
                            mismatches: combined
                        }
                    };
                });
            }
        );
    }

    openAddressMismatchModal = (mismatch, index = null, items = null) => {
        this.setState({
            addressMismatchModal: {
                show: true,
                mismatches: [],
                index: index,
                items: items,
                isSaving: false,
                savingMismatchKey: null
            },
            rowLoading: null
        }, () => this.loadPreviewAddressMismatches(mismatch, items))
    }

    addressMismatchFrom = (res) => {
        return this.addressMismatchesFrom(res)[0];
    }

    handleQuickbooksError = (res, index = null, items = null) => {
        const data = res?.data || res || {};
        const mismatch = this.addressMismatchFrom(data);

        if (mismatch) {
            this.openAddressMismatchModal(mismatch, index, items);
            return true;
        }

        if (data?.message || data?.error_sites) {
            this.setState({
                errorModal: {
                    show: true,
                    message: data?.message,
                    error_sites: data?.error_sites
                },
                rowLoading: null
            });
            return true;
        }

        return false;
    }

    handleCustomerSyncResult = (res, index, items, refresh, options = {}) => {
        const {refreshAfterHandledError = true} = options;
        const hasAddressMismatch = !!this.addressMismatchFrom(res);
        const handled = this.handleQuickbooksError(res, index, items);

        if (!handled || (refreshAfterHandledError && !hasAddressMismatch)) {
            refresh();
        }

        return handled;
    }

    acceptAddressMismatch = (mismatch) => {
        const {addressMismatchModal} = this.state;
        const mismatchKey = mismatch._modalKey || this.mismatchKey(mismatch);

        if (!(["site", "customer"].includes(mismatch.record_type) && mismatch.quickbooks_id)) {
            return;
        }

        this.setState({
            addressMismatchModal: {
                ...addressMismatchModal,
                isSaving: true,
                savingMismatchKey: mismatchKey
            }
        }, () => {
            const siteSyncPreferences = _.get(addressMismatchModal.items, 'qb.sites', []).map(site => ({
                quickbooks_id: site.quickbooks_id,
                s_address_sync: site.s_address_sync
            }));

            this.props.actions.acceptAddressMismatch({
                    record_type: mismatch.record_type,
                    record_id: mismatch.record_id,
                    address: mismatch.proposed_address,
                    s_address_sync: mismatch.s_address_sync,
                    quickbooks_id: mismatch.quickbooks_id,
                    customer_id: addressMismatchModal.items?.th?.id,
                    customer_quickbooks_id: mismatch.customer_quickbooks_id,
                    site_sync_preferences: siteSyncPreferences
                },
                () => {
                    const remainingMismatches = (addressMismatchModal.mismatches || []).filter(item => item._modalKey !== mismatchKey);

                    this.setState({
                        addressMismatchModal: remainingMismatches.length > 0
                            ? {
                                ...addressMismatchModal,
                                mismatches: remainingMismatches,
                                isSaving: false,
                                savingMismatchKey: null
                            }
                            : {show: false, mismatches: [], index: null, items: null, isSaving: false, savingMismatchKey: null},
                        rowLoading: null
                    }, () => {
                        if (remainingMismatches.length === 0) {
                            const qbId = addressMismatchModal.items?.qb?.quickbooks_id;
                            if (qbId) {
                                this.syncCustomer(qbId, addressMismatchModal.index, false);
                            }
                        }
                    });
                },
                (res) => {
                    const hasAddressMismatch = !!this.addressMismatchFrom(res);

                    if (this.handleQuickbooksError(res, addressMismatchModal.index, addressMismatchModal.items)) {
                        if (hasAddressMismatch) {
                            const qbId = addressMismatchModal.items?.qb?.quickbooks_id;
                            if (qbId) {
                                this.syncCustomer(qbId, addressMismatchModal.index, false);
                            }
                        } else {
                            this.setState(prevState => ({
                                addressMismatchModal: {
                                    ...prevState.addressMismatchModal,
                                    isSaving: false,
                                    savingMismatchKey: null
                                }
                            }));
                        }
                        return;
                    }

                    this.setState({
                        addressMismatchModal: {
                            ...addressMismatchModal,
                            isSaving: false,
                            savingMismatchKey: null
                        },
                        rowLoading: null
                    });
                }
            )
        });
    }

    sortSites = customer => {
        if (customer?.sites) {
            customer.sites.sort((a, b) => {
                if (b.name.trim() < a.name.trim()) {
                    return -1;
                }
                if (b.name.trim() > a.name.trim()) {
                    return 1;
                }
                return 0;
            });
        }
    };

    syncCustomer = (id, index, isThCustomer = false) => {
        let { content } = this.state;

        this.props.actions.getQbCustomer(
            id,
            isThCustomer,
            result => {
                const customer = result.content;

                if (customer) {
                    this.sortSites(customer);
                    this.sortSites(customer?.customer);

                    if (isThCustomer) {
                        content[index].th = customer;
                        content[index].qb = customer.customer || content[index].qb;
                    } else {
                        content[index].qb = customer;
                        content[index].th = customer.customer || content[index].th;
                    }

                    if (content[index].qb && content[index].th) {
                        this.refreshAddress(content[index].qb, content[index].th, index);
                    }
                }

                this.setState({ content, rowLoading: null });
            },
            res => {
                if (res?.data?.message) {
                    this.setState({
                        errorModal: {
                            show: true,
                            message: res.data.message
                        }
                    });
                }

                this.setState({ content, rowLoading: null });
            }
        );
    };

    assignCustomer = (customer, index) => {
        const {content} = this.state;
        const obj = {
            id: customer.id,
            quickbooks_id: customer.quickbooks_id,
            company_name: customer.company_name,
            first_name: customer.first_name,
            last_name: customer.last_name,
            address_1: customer.address_1,
            address_2: customer.address_2,
            state: customer.state,
            zip: customer.zip,
            city: customer.city,
            s_address_1: customer.s_address_1,
            s_address_2: customer.s_address_2,
            s_state: customer.s_state,
            s_zip: customer.s_zip,
            s_city: customer.s_city,
            email_address: customer.email_address,
            phone_number: customer.phone_number,
            isAssigned: true
        }
        content[index]["th"] = obj
        this.setState({
            content: content,
            isSearching: false
        });
    }

    assignQbCustomer = (customer, index) => {
        let {content} = this.state;
        customer.isAssigned = true;
        content[index]["qb"] = customer;
        this.setState({
            content: content,
            isSearching: false
        });
    }

    syncAllOnThisPage = () => {
        this.setState({syncAllModal: !this.state.syncAllModal})
    }

    handleSearchQbCustomer = (resource, index) => {
        if (resource[`qb_customer_${index}`]) {
            this.props.actions.getQbCustomer(resource[`qb_customer_${index}`], false, (response) =>
                this.assignQbCustomer(response.content, index))
        }
    }

    handleSearchCustomer = (resource, index, callback = null) => {
        if (resource[`customer_id_${index}`]) {
            this.props.actions.getQbCustomer(resource[`customer_id_${index}`], true, (response) => {
                this.assignCustomer(response.content, index)
                callback && callback(response);
            })
        }
    }


    searchUser = (index, user) => {
        const customerOptions = this.customerSearch.searchOptions();
        const {resource, content, editedRow, refreshingCustomerId, closeEditRow} = this.state;
        const isRefreshing = user?.id === refreshingCustomerId
        const deleteable = content[index]["qb"] && content[index]["th"] && content[index]["qb"].quickbooks_id !== content[index]["th"].quickbooks_id

        return (
            <div>{
                content[index]["th"] ? <Row>
                        {deleteable && <Col md={1} className='text-right flex-column-start'>
                            <FontAwesomeIcon
                                className="pointer"
                                icon={faTimesCircle}
                                size="1x"
                                data-toggle={'tooltip'}
                                title={'Delete match'}
                                onClick={() => {
                                    const {content} = this.state
                                    if (content[index]) {
                                        content[index].th = null;
                                        this.setState(content);
                                    }
                                }}/>
                            <FontAwesomeIcon
                                className={`pointer mt-3 ${isRefreshing ? 'refresh-customer-active' : ''}`}
                                icon={faSync}
                                size="1x"
                                data-toggle={'tooltip'}
                                title={'Refresh customer'}
                                onClick={() => {
                                    const {content} = this.state

                                    if (!refreshingCustomerId) {
                                        this.setState({refreshingCustomerId: user.id})
                                        this.refreshCustomerRow(index, content[index], {
                                            side: 'th',
                                            refreshAddressMap: false,
                                            onComplete: () => this.setState({refreshingCustomerId: null})
                                        })
                                    }
                                }}/>
                        </Col>}
                        <Col md={10}>
                            <InlineEditable
                                style={{minWidth: "50%"}}
                                className="pointer"
                                fullWidth={true}
                                onClick={() => !editedRow && this.setState({editedRow: true, closeEditRow: false})}
                                editable={!editedRow}
                                value={this.userDataField(content[index]["th"], content[index]["qb"], "left", index, true)}
                                handleSubmit={() => {
                                    this.setState({editedRow: null})
                                    this.handleSearchCustomer(resource, index)
                                }}
                                closeEdit={closeEditRow}
                                closeEditable={() => this.setState({closeEditRow: null})}
                                form={() =>
                                    <Select className="Select"
                                            classNamePrefix="select"
                                            value={select(customerOptions, resource[`customer_id_${index}`])}
                                            options={customerOptions}
                                            placeholder="Customer"
                                            filterOption={false}
                                            isClearable
                                            isLoading={resource.customer_id && resource.customer_id.length < 1}
                                            onInputChange={this.customerSearch.search}
                                            onChange={this.selectResourceAttr(`customer_id_${index}`)}
                                    />
                                }
                            />
                        </Col>
                        <Col md={1}>
                            <div onClick={() => {
                                let rows = this.state.collapsedRows
                                if (rows.includes(index)) {
                                    rows = rows.filter(r => r !== index)
                                } else {
                                    rows.push(index)
                                }
                                this.setState({collapsedRows: rows})
                            }}>
                                {this.state.collapsedRows.includes(index) ? <FontAwesomeIcon
                                    className={`pointer`}
                                    size='2x'
                                    icon={faAngleUp}/> : <FontAwesomeIcon
                                    className={`pointer`}
                                    size='2x'
                                    icon={faAngleDown}/>}
                            </div>
                        </Col>
                    </Row> :
                    <Row>
                        <Col xs={12} className="hover-cell">
                            <InlineEditable
                                style={{minWidth: "50%"}}
                                className="pointer"
                                onClick={() => !editedRow && this.setState({editedRow: true, closeEditRow: false})}
                                editable={!editedRow}
                                value={<h4><b>Not Assigned</b></h4>}
                                handleSubmit={() => {
                                    this.setState({editedRow: null})
                                    this.handleSearchCustomer(resource, index)
                                }}
                                closeEdit={closeEditRow}
                                closeEditable={() => this.setState({closeEditRow: null})}
                                form={() =>
                                    <Select className="Select"
                                            classNamePrefix="select"
                                            value={select(customerOptions, resource[`customer_id_${index}`])}
                                            options={customerOptions}
                                            placeholder="Customer"
                                            filterOption={false}
                                            isClearable
                                            isLoading={resource.customer_id && resource.customer_id.length < 1}
                                            onInputChange={this.customerSearch.search}
                                            onChange={this.selectResourceAttr(`customer_id_${index}`)}
                                    />
                                }
                            />
                        </Col>
                    </Row>
            }
            </div>
        );
    }

    searchQbUser = (index) => {
        const {
            resource,
            content,
            customerQbOptions,
            isSearchingQbCustomer,
            editedRow,
            refreshingCustomerId,
            closeEditRow
        } = this.state;

        const searchFn = e => {
            if (e && e.length > 0 && !isSearchingQbCustomer) {
                this.setState({isSearchingQbCustomer: true})
                this.qbCustomerSearch.search(e)
            }
        }
        const debouncedSearchFn = debounce(1000, searchFn);
        const isRefreshing = content[index]["qb"]?.quickbooks_id === refreshingCustomerId
        const deleteable = content[index]["qb"] && content[index]["th"] && content[index]["qb"].quickbooks_id !== content[index]["th"].quickbooks_id
        return (
            <div>{
                content[index]["qb"] ?
                    <Row>
                        <Col md={10}>
                            <InlineEditable
                                style={{minWidth: "50%"}}
                                className="pointer"
                                fullWidth={true}
                                onClick={() => !editedRow && this.setState({editedRow: true, closeEditRow: false})}
                                editable={!editedRow}
                                value={this.userDataField(content[index]["qb"], content[index]["th"], "right", index, true)}
                                handleSubmit={() => {
                                    this.handleSearchQbCustomer(resource, index);
                                    this.setState({editedRow: null, customerQbOptions: []})
                                }}
                                closeEdit={closeEditRow}
                                closeEditable={() => this.setState({closeEditRow: null})}
                                form={(done) =>
                                    <Select className="Select"
                                            classNamePrefix="select"
                                            value={select(customerQbOptions, resource[`qb_customer_${index}`])}
                                            options={!isSearchingQbCustomer ? customerQbOptions : []}
                                            placeholder="Customer"
                                            filterOption={false}
                                            isClearable
                                            isDisabled={isSearchingQbCustomer}
                                            isLoading={isSearchingQbCustomer}
                                            onInputChange={debouncedSearchFn}
                                            onChange={this.selectResourceAttr(`qb_customer_${index}`)}
                                    />
                                }
                            />
                        </Col>
                        <Col md={1}>
                            <div onClick={() => {
                                let rows = this.state.collapsedRows
                                if (rows.includes(index)) {
                                    rows = rows.filter(r => r !== index)
                                } else {
                                    rows.push(index)
                                }
                                this.setState({collapsedRows: rows})
                            }}>
                                {this.state.collapsedRows.includes(index) ? <FontAwesomeIcon
                                    className={`pointer`}
                                    size='2x'
                                    icon={faAngleUp}/> : <FontAwesomeIcon
                                    className={`pointer`}
                                    size='2x'
                                    icon={faAngleDown}/>}
                            </div>
                        </Col>
                        {deleteable &&
                            <Col md={1} className='text-right'>
                                <FontAwesomeIcon
                                    className="pointer"
                                    icon={faTimesCircle}
                                    size="1x"
                                    data-toggle={'tooltip'}
                                    title={'Delete match'}
                                    onClick={() => {
                                        const {content} = this.state
                                        if (content[index]) {
                                            content[index].qb = null;
                                            this.setState(content);
                                        }
                                    }}/>
                                <FontAwesomeIcon
                                    className={`pointer mt-3 ${isRefreshing ? 'refresh-customer-active' : ''}`}
                                    icon={faSync}
                                    size="1x"
                                    data-toggle={'tooltip'}
                                    title={'Refresh customer'}
                                    onClick={() => {
                                        const {content} = this.state
                                        if (!refreshingCustomerId) {
                                            this.setState({refreshingCustomerId: content[index]["qb"].quickbooks_id})
                                            this.refreshCustomerRow(index, content[index], {
                                                side: 'qb',
                                                refreshAddressMap: false,
                                                onComplete: () => this.setState({refreshingCustomerId: null})
                                            })
                                        }
                                    }}/>
                            </Col>
                        }
                    </Row> :
                    <Row>
                        <Col xs={12} className="hover-cell">
                            <InlineEditable
                                style={{minWidth: "50%"}}
                                className="pointer"
                                onClick={() => !editedRow && this.setState({editedRow: true, closeEditRow: false})}
                                editable={!editedRow}
                                value={<h4><b>Not Assigned</b></h4>}
                                handleSubmit={() => {
                                    this.handleSearchQbCustomer(resource, index);
                                    this.setState({editedRow: null, customerQbOptions: []})
                                }}
                                closeEdit={closeEditRow}
                                closeEditable={() => this.setState({closeEditRow: null})}
                                form={() =>
                                    <Select className="Select"
                                            classNamePrefix="select"
                                            value={select(customerQbOptions, resource[`qb_customer_${index}`])}
                                            options={!isSearchingQbCustomer ? customerQbOptions : []}
                                            placeholder="Customer"
                                            filterOption={false}
                                            isClearable
                                            isDisabled={isSearchingQbCustomer}
                                            isLoading={isSearchingQbCustomer}
                                            onInputChange={debouncedSearchFn}
                                            onChange={this.selectResourceAttr(`qb_customer_${index}`)}
                                    />
                                }
                            />
                        </Col>
                    </Row>
            }

            </div>
        );
    }

    formatAddress2 = address => {
        if (address) {
            return ' ' + address
        } else {
            return ''
        }
    }

    addressFormatter = (cell, row, enumObj, siteIndex, template, column, userIndex) => {
        const sync = this.state.addressSyncMap?.[userIndex]?.[siteIndex]?.s_address_sync;

        row.address_1 = row.address_1 || row.address;
        const address = (sync && column === 'right') ? row.s_address_1 + this.formatAddress2(row.s_address_2) : row.address_1 + this.formatAddress2(row.address_2);
        const templateAddress = column === 'right'
            ? template?.sites?.[siteIndex]?.address_1?.trim() + this.formatAddress2(template?.sites?.[siteIndex]?.address_2?.trim())
            : (sync ? template?.sites?.[siteIndex]?.s_address_1?.trim() + this.formatAddress2(template?.sites?.[siteIndex]?.s_address_2?.trim()) : template?.sites?.[siteIndex]?.address_1?.trim() + this.formatAddress2(template?.sites?.[siteIndex]?.address_2?.trim()));

        return (
            <>
                <OverlayTrigger placement="right"
                                overlay={<Tooltip id="tooltip">{address}</Tooltip>}>
                    <p style={{color: templateAddress.trim() === address?.trim() ? "green" : "red"}}>
                        {address}
                    </p>
                </OverlayTrigger>
            </>
        );
    };

    nameFormatter = (cell, row, enumObj, index, template) => {
        return (
            <>
                <OverlayTrigger placement="right"
                                overlay={<Tooltip id="tooltip">{cell.trim()}</Tooltip>}>
                    <p
                        style={{color: template && template.sites && template.sites[index] && template.sites[index].name && template.sites[index].name?.trim() === cell?.trim() ? "green" : "red"}}>{cell.trim()}</p>
                </OverlayTrigger>
            </>
        )
    }

    cityFormatter = (cell, row, enumObj, siteIndex, template, column, userIndex) => {
        const sync = this.state.addressSyncMap?.[userIndex]?.[siteIndex]?.s_address_sync;

        const city = (sync && column === 'right') ? row.s_city : row.city;
        const templateCity = column === 'right'
            ? template?.sites?.[siteIndex]?.city?.trim()
            : (sync ? template?.sites?.[siteIndex]?.s_city?.trim() : template?.sites?.[siteIndex]?.city?.trim());

        return (
            <>
                <OverlayTrigger placement="right"
                                overlay={<Tooltip id="tooltip">{city}</Tooltip>}>
                    <p style={{color: templateCity === city?.trim() ? "green" : "red"}}>
                        {city}
                    </p>
                </OverlayTrigger>
            </>
        );
    };

    zipFormatter = (cell, row, enumObj, siteIndex, template, column, userIndex) => {
        const sync = this.state.addressSyncMap?.[userIndex]?.[siteIndex]?.s_address_sync;

        const zip = (sync && column === 'right') ? row.s_zip : row.zip;
        const templateZip = column === 'right'
            ? template?.sites?.[siteIndex]?.zip?.trim()
            : (sync ? template?.sites?.[siteIndex]?.s_zip?.trim() : template?.sites?.[siteIndex]?.zip?.trim());

        return (
            <>
                <OverlayTrigger placement="right"
                                overlay={<Tooltip id="tooltip">{zip}</Tooltip>}>
                    <p style={{color: templateZip === zip?.trim() ? "green" : "red"}}>
                        {zip}
                    </p>
                </OverlayTrigger>
            </>
        );
    };

    countryFormatter = (cell, row, enumObj, siteIndex, template, column, userIndex) => {
        const sync = this.state.addressSyncMap?.[userIndex]?.[siteIndex]?.s_address_sync;

        const country = (sync && column === 'right') ? row.s_country : row.country;
        const templateCountry = column === 'right'
            ? template?.sites?.[siteIndex]?.country?.trim()
            : (sync ? template?.sites?.[siteIndex]?.s_country?.trim() : template?.sites?.[siteIndex]?.country?.trim());

        return (
            <>
                <OverlayTrigger placement="right"
                                overlay={<Tooltip id="tooltip">{country}</Tooltip>}>
                    <p style={{color: templateCountry === country?.trim() ? "green" : "red"}}>
                        {country}
                    </p>
                </OverlayTrigger>
            </>
        );
    };

    siteSyncFormatter = (cell, row, enumObj, siteIndex, template, index, column) => {
        const {content} = this.state
        const useShippingAddress = this.state.addressSyncMap?.[index]?.[siteIndex]?.s_address_sync || false
        const hasFullAddress = useShippingAddress && column === 'right' ? (row.s_address_1 && row.s_city && row.s_state && row.s_zip && row.s_country)
            : (row.address_1 && row.city && row.state && row.zip && row.country)

        const allowSync = template?.quickbooks_id || template?.customer?.quickbooks_id
        return <span className="flex-column-center">
            <OverlayTrigger placement="right" overlay={<Tooltip id="tooltip">Sync site</Tooltip>}>
                <FontAwesomeIcon
                    className={`pointer ${(allowSync && hasFullAddress) ? '' : 'arrow-disabled'}`}
                    style={{color: allowSync ? 'green' : 'gray'}}
                    icon={template?.id ? faLongArrowAltLeft : faLongArrowAltRight}
                    size="1x"
                    onClick={() => {
                        allowSync && hasFullAddress && this.setState({rowLoading: index}, () => {
                            this.props.actions.syncCustomersSite({
                                    site_id: row.id,
                                    quickbooks_id: row.quickbooks_id,
                                    customer_quickbooks_id: row.quickbooks_parent_ref,
                                    s_address_sync: useShippingAddress
                                },
                                () => {
                                    this.refreshCustomerRow(index, content[index], {
                                        thId: template?.id || template?.customer?.id,
                                        qbId: template?.quickbooks_id || template?.customer?.quickbooks_id,
                                        onComplete: () => this.setState({rowLoading: null})
                                    })
                                },
                                (res) => {
                                    if (!this.handleQuickbooksError(res, index, content[index])) {
                                        this.setState({rowLoading: null})
                                    }
                                }
                            )
                        })
                    }}
                />
            </OverlayTrigger>
            {allowSync && row.id && row.quickbooks_sub_customer_id && <OverlayTrigger placement='right'
                                                                                      overlay={<Tooltip id='tooltip'>Remove
                                                                                          Quickbook ID from this
                                                                                          Site</Tooltip>}>
                <FontAwesomeIcon
                    className="pointer mt7"
                    style={{color: row.id ? 'red' : '#ff9999'}}
                    icon={faMinusCircle}
                    onClick={() => {
                        if (row.id) {
                            const choice = window.confirm('Are you sure you want to delete Quickbook ID?');
                            if (choice) {
                                this.props.actions.removeSiteQBId(row.id, () => {
                                    this.refreshCustomerRow(index, content[index], {
                                        side: 'th',
                                        thId: row.customer_id
                                    })
                                })
                            }
                        }
                    }}
                />
            </OverlayTrigger>}
            {!hasFullAddress && <OverlayTrigger placement='right'
                                                overlay={<Tooltip id='tooltip'>The address is incomplete. This site will
                                                    be skipped.</Tooltip>}>
                <FontAwesomeIcon
                    className="mt7"
                    style={{color: '#ff9999'}}
                    icon={faInfoCircle}
                />
            </OverlayTrigger>
            }
        </span>
    }

    stateFormatter = (cell, row, enumObj, siteIndex, template, column, userIndex) => {
        const sync = this.state.addressSyncMap?.[userIndex]?.[siteIndex]?.s_address_sync;

        const state = (sync && column === 'right') ? row.s_state : row.state;
        const templateState = column === 'right'
            ? template?.sites?.[siteIndex]?.state?.trim()
            : (sync ? template?.sites?.[siteIndex]?.s_state?.trim() : template?.sites?.[siteIndex]?.state?.trim());

        return (
            <>
                <OverlayTrigger placement="right"
                                overlay={<Tooltip id="tooltip">{state}</Tooltip>}>
                    <p style={{color: templateState === state?.trim() ? "green" : "red"}}>
                        {state}
                    </p>
                </OverlayTrigger>
            </>
        );
    };

    idFormatter = (cell, row) => {
        return row.id ? row.id : row.quickbooks_id;
    }

    changeAddressFormatter = (cell, row, enumObj, siteIndex, userIndex) => {
        const hasShippingAddress = row.s_address_1 || row.s_city || row.s_state || row.s_zip || row.s_country;

        if (!hasShippingAddress) {
            return (
                <OverlayTrigger
                    placement="right"
                    overlay={<Tooltip id="tooltip">Shipping address doesn't exist</Tooltip>}
                >
                    <span>Not sync shipping</span>
                </OverlayTrigger>
            );
        }

        const useShippingAddress = this.state.addressSyncMap?.[userIndex]?.[siteIndex]?.s_address_sync || false;
        const title = useShippingAddress ? "Change to billing address" : "Change to shipping address";
        const tooltipText = useShippingAddress ? "Shipping" : "Billing";
        const isSameAddress =
            row.s_address_1 === row.address_1 &&
            row.s_address_2 === row.address_2 &&
            row.s_city === row.city &&
            row.s_state === row.state &&
            row.s_zip === row.zip &&
            row.s_country === row.country;

        if (isSameAddress) {
            return (
                <OverlayTrigger
                    placement="right"
                    overlay={<Tooltip id="tooltip">Shipping / Billing</Tooltip>}
                >
                    <span>Shipping / Billing</span>
                </OverlayTrigger>
            );
        }

        return (
            <OverlayTrigger
                placement="right"
                overlay={<Tooltip id="tooltip">{tooltipText}</Tooltip>}
            >
            <span className="pointer" title={title} onClick={() => {
                this.setState(prev => {
                    const current = prev.addressSyncMap?.[userIndex]?.[siteIndex]?.s_address_sync || false;
                    return {
                        addressSyncMap: {
                            ...prev.addressSyncMap,
                            [userIndex]: {
                                ...prev.addressSyncMap?.[userIndex],
                                [siteIndex]: {
                                    s_address_sync: !current
                                }
                            }
                        }
                    };
                });
            }}>
                <FontAwesomeIcon icon={faExchangeAlt}/>
                {tooltipText}
            </span>
            </OverlayTrigger>
        );
    };


    hasAnyShippingAddress = (user) => {
        return user.sites.some(row =>
            row.s_address_1 || row.s_city || row.s_state || row.s_zip || row.s_country
        );
    }

    refreshAddress = (user, template, userIndex) => {
        const updatedSites = {};
        const previousSites = this.state.addressSyncMap?.[userIndex] || {};

        const userSites = user.sites || [];
        const templateSites = template?.sites || [];

        userSites.forEach((site, siteIndex) => {
            const templateSite = templateSites[siteIndex];
            const previousSync = previousSites[siteIndex]?.s_address_sync;

            const matchShipping = (
                templateSite &&
                site.s_address_1?.trim() === templateSite.address_1?.trim() &&
                site.s_address_2?.trim() === templateSite.address_2?.trim() &&
                site.s_state?.trim() === templateSite.state?.trim() &&
                site.s_zip?.trim() === templateSite.zip?.trim() &&
                site.s_city?.trim() === templateSite.city?.trim()
            );

            updatedSites[siteIndex] = {
                s_address_sync: previousSync ?? matchShipping
            };
        });

        this.setState(prev => ({
            addressSyncMap: {
                ...prev.addressSyncMap,
                [userIndex]: updatedSites
            }
        }));
    };


    refreshAllAddresses = () => {
        const updatedMap = {};

        this.state.content.forEach((row, userIndex) => {
            const userSites = row.qb?.sites || [];
            const templateSites = row.th?.sites || [];
            const siteSyncMap = {};

            userSites.forEach((site, siteIndex) => {
                const templateSite = templateSites[siteIndex];

                const matchShipping = templateSite &&
                    site.s_address_1?.trim() === (templateSite.address_1 || templateSite.address)?.trim() &&
                    site.s_address_2?.trim() === (templateSite.address_2 || templateSite.address_2)?.trim() &&
                    site.s_state?.trim() === templateSite.state?.trim() &&
                    site.s_zip?.trim() === templateSite.zip?.trim() &&
                    site.s_city?.trim() === templateSite.city?.trim();

                siteSyncMap[siteIndex] = {
                    s_address_sync: matchShipping
                };
            });

            updatedMap[userIndex] = siteSyncMap;
        });

        this.setState({addressSyncMap: updatedMap});
    };

    changeShippingAddress = () => {
        const {addressSyncMap} = this.state;
        const {shippingAddressSync} = this.props;

        const updatedMap = {...addressSyncMap};

        this.state.content.forEach((row, userIndex) => {
            const userSites = row.qb?.sites || [];

            userSites.forEach((site, siteIndex) => {
                const hasAllFields =
                    site.s_address_1 ||
                    site.s_city ||
                    site.s_state ||
                    site.s_zip ||
                    site.s_country;

                if (!updatedMap[userIndex]) {
                    updatedMap[userIndex] = {};
                }

                updatedMap[userIndex][siteIndex] = {
                    s_address_sync: shippingAddressSync && hasAllFields
                };
            });
        });

        this.setState({addressSyncMap: updatedMap});
    };

    userDataField = (user, template, column, index, isEditable) => {
        const {refreshingCustomerId} = this.state
        const isRefreshing = (column === 'right' && user.quickbooks_id === refreshingCustomerId) || user.id === refreshingCustomerId
        const phones = o =>
            [o.phone_number, o.mobile_number, o.phone_number2]
                .filter(Boolean)
                .flatMap(v => v.split(","))
                .map(v => v.trim())
                .filter(Boolean)
                .sort()
                .join("|");

        const emails = o =>
            (o.email_address || "")
                .split(",")
                .map(e => e.trim())
                .filter(Boolean)
                .sort()
                .join("|");

        const isEmailMatch = template && emails(user) === emails(template);
        const isPhoneMatch = template && phones(user) === phones(template);

        return (
            <Row>
                {!isEditable && column === 'left' &&
                    <Col md={1} className='text-right flex-column-start'>
                        {user && template && user.quickbooks_id !== template.quickbooks_id && <FontAwesomeIcon
                            className="pointer"
                            icon={faTimesCircle}
                            size="1x"
                            data-toggle={'tooltip'}
                            title={'Delete match'}
                            onClick={() => {
                                const {content} = this.state
                                if (content[index]) {
                                    content[index].th = null;
                                    this.setState(content);
                                }
                            }}/>}
                        <FontAwesomeIcon
                            className={`pointer mt-3 ${isRefreshing ? 'refresh-customer-active' : ''}`}
                            icon={faSync}
                            size="1x"
                            data-toggle={'tooltip'}
                            title={'Refresh customer'}
                            onClick={() => {
                                const {content} = this.state

                                if (!refreshingCustomerId) {
                                    if (column === 'right') {
                                        if (user?.quickbooks_id) {
                                            this.setState({refreshingCustomerId: user.quickbooks_id})
                                            this.refreshCustomerRow(index, content[index], {
                                                side: 'qb',
                                                refreshAddressMap: false,
                                                onComplete: () => this.setState({refreshingCustomerId: null})
                                            })
                                        }
                                    } else {
                                        this.setState({refreshingCustomerId: user.id})
                                        this.refreshCustomerRow(index, content[index], {
                                            side: 'th',
                                            refreshAddressMap: false,
                                            onComplete: () => this.setState({refreshingCustomerId: null})
                                        })
                                    }
                                }
                            }}/>
                    </Col>
                }
                {this.state.collapsedRows.includes(index) ? <Col md={isEditable ? 12 : 10}>
                        <Row>
                            <Col style={{textDecoration: "none"}} className="text-right" xs={3}>
                                Company Name:
                            </Col>
                            <Col xs={9} className="text-left"
                                 style={{color: template && user.company_name?.trim() === template.company_name?.trim() ? "green" : "red"}}>
                                <p>{user.company_name}</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col style={{textDecoration: "none"}} className="text-right" xs={3}>
                                Name:
                            </Col>
                            <Col xs={9} className="text-left" style={{
                                color: template && user.first_name?.trim() === template.first_name?.trim() && user.last_name?.trim()
                                === template.last_name?.trim() ? "green" : "red", marginBottom: '9px'
                            }}>
                                {column === 'left' ?
                                    <OverlayTrigger
                                        placement='bottom'
                                        overlay={
                                            <Tooltip id='tooltip-customer-info'>
                                                Show customer
                                            </Tooltip>
                                        }
                                    >
                                        <Link target="_blank" to={`/customer/info/${user?.id}`} style={{
                                            color: template && user.first_name?.trim() === template.first_name?.trim() && user.last_name?.trim()
                                            === template.last_name?.trim() ? "green" : "red"
                                        }}>
                                            <span>{user.first_name} {user.last_name}</span>
                                        </Link>
                                    </OverlayTrigger>
                                    :
                                    <span>{user.first_name} {user.last_name}</span>
                                }
                            </Col>
                        </Row>
                        <Row>
                            <Col style={{textDecoration: "none"}} className="text-right" xs={3}>
                                Billing Address:
                            </Col>
                            <Col xs={9} className="text-left" style={{
                                color: template && user.address_1?.trim() === template.address_1?.trim() && ((!!user.address_2 && !!template.address_2 && user.address_2?.trim() === template.address_2?.trim()) || (!user.address_2 && !template.address_2)) && user.state?.trim()
                                === template.state?.trim() && user.zip?.trim() === template.zip?.trim() && user.city?.trim() === template.city?.trim() ? "green" : "red"
                            }}>
                                <p>{user.address_1} {user.address_2} {user.city} {user.state} {user.zip}</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col style={{textDecoration: "none"}} className="text-right" xs={3}>
                                Email:
                            </Col>
                            <Col xs={8} className="text-left"
                                 style={{
                                     color: template && isEmailMatch ? "green" : "red",
                                     wordBreak: "break-all"
                                 }}>
                                <p>{user.email_address}</p>
                            </Col>
                            <Col xs={1}>
                                {(user.quickbooks_id && template && template.quickbooks_id && +user.quickbooks_id === +template.quickbooks_id) &&
                                    <div style={{textDecoration: "none"}} className="text-right">
                                        {column === 'right' ?
                                            user.email_address && user.email_address.length > 0 && template &&
                                            <div>
                                                <FontAwesomeIcon className="pointer"
                                                                 icon={faLongArrowAltLeft}
                                                                 data-toggle='tooltip'
                                                                 title='Move only email address'
                                                                 onClick={() => this.setState({rowLoading: index}, () => this.props.actions.updateThParam({
                                                                         id: user.customer.id,
                                                                         email_address: user.email_address
                                                                     }, () => this.syncCustomer(user.quickbooks_id, index, false),
                                                                     (res) => {
                                                                         if (res?.data?.message) {
                                                                             this.setState({
                                                                                 errorModal: {
                                                                                     show: true,
                                                                                     message: res?.data?.message
                                                                                 },
                                                                                 rowLoading: null
                                                                             })
                                                                         }
                                                                     }))}
                                                                 size="1x"/>
                                            </div>
                                            : user.email_address && user.email_address.length > 0 && template &&
                                            <div>
                                                <FontAwesomeIcon className="pointer"
                                                                 icon={faLongArrowAltRight}
                                                                 data-toggle='tooltip'
                                                                 title='Move only email address'
                                                                 onClick={() => this.setState({rowLoading: index}, () => this.props.actions.updateQbParam({
                                                                         id: user.quickbooks_id,
                                                                         email_address: user.email_address
                                                                     }, () => this.syncCustomer(user.id, index, true),
                                                                     (res) => {
                                                                         if (res?.data?.message) {
                                                                             this.setState({
                                                                                 errorModal: {
                                                                                     show: true,
                                                                                     message: res?.data?.message
                                                                                 },
                                                                                 rowLoading: null
                                                                             })
                                                                         }
                                                                     }))}
                                                                 size="1x"/>
                                            </div>}
                                    </div>}
                            </Col>
                        </Row>
                        <Row>
                            <Col style={{textDecoration: "none"}} xs={3} className="text-right">
                                Phone number:
                            </Col>
                            <Col xs={8} className="text-left"
                                 style={{ color: template && isPhoneMatch ? "green" : "red" }}>
                                <p>
                                    {user.phone_number}
                                    {user.mobile_number && `, ${user.mobile_number}`}
                                    {user.phone_number2 && `, ${user.phone_number2}`}
                                </p>
                            </Col>
                            <Col xs={1}>
                                {(user.quickbooks_id && template && template.quickbooks_id && +user.quickbooks_id === +template.quickbooks_id) &&
                                    <div style={{textDecoration: "none"}} className="text-right">
                                        {column === 'right' ?
                                            user.phone_number && user.phone_number.length > 0 && template &&
                                            <div>
                                                <FontAwesomeIcon className="pointer"
                                                                 icon={faLongArrowAltLeft}
                                                                 data-toggle='tooltip'
                                                                 title='Move only phone number'
                                                                 onClick={() => this.setState({rowLoading: index}, () => this.props.actions.updateThParam({
                                                                         id: user.customer.id,
                                                                         phone_number: user.phone_number,
                                                                         mobile_number: user.mobile_number
                                                                     }, () => this.syncCustomer(user.quickbooks_id, index, false),
                                                                     (res) => {
                                                                         if (res?.data?.message) {
                                                                             this.setState({
                                                                                 errorModal: {
                                                                                     show: true,
                                                                                     message: res?.data?.message
                                                                                 },
                                                                                 rowLoading: null
                                                                             })
                                                                         }
                                                                     }))}
                                                                 size="1x"/>
                                            </div>
                                            : user.phone_number && user.phone_number.length > 0 && template &&
                                            <div>
                                                <FontAwesomeIcon className="pointer"
                                                                 icon={faLongArrowAltRight}
                                                                 data-toggle={'tooltip'}
                                                                 title={'Move only phone number'}
                                                                 onClick={() => this.setState({rowLoading: index}, () => this.props.actions.updateQbParam({
                                                                         id: user.quickbooks_id,
                                                                         phone_number: user.phone_number,
                                                                         mobile_number: user.phone_number2
                                                                     }, () => this.syncCustomer(user.id, index, true),
                                                                     (res) => {
                                                                         if (res?.data?.message) {
                                                                             this.setState({
                                                                                 errorModal: {
                                                                                     show: true,
                                                                                     message: res?.data?.message
                                                                                 },
                                                                                 rowLoading: null
                                                                             })
                                                                         }
                                                                     }))}
                                                                 size="1x"/>
                                            </div>}
                                    </div>}
                            </Col>
                        </Row>
                        <Row>
                            <Col style={{textDecoration: "none"}} className="text-right" xs={3}>
                                Sites:
                            </Col>
                            <Col xs={9}>
                                {user.sites && user.sites.length > 0 &&
                                    <BootstrapTable
                                        ref="table"
                                        data={user.sites}
                                        striped={false}
                                        bordered
                                        remote
                                        className="wrapped"
                                    >
                                        {this.hasAnyShippingAddress(user) && (
                                            <TableHeaderColumn
                                                dataField=""
                                                dataFormat={(cell, row, enumObj, siteIndex) => this.changeAddressFormatter(cell, row, enumObj, siteIndex, index)}
                                                columnClassName="icon-column"
                                                headerAlign="right"
                                            >
                                                Address Type
                                            </TableHeaderColumn>
                                        )}
                                        <TableHeaderColumn
                                            dataField="id"
                                            hidden
                                            isKey
                                            dataFormat={(cell, row) => this.idFormatter(cell, row)}
                                        />
                                        <TableHeaderColumn
                                            className='align-center'
                                            columnClassName='align-center'
                                            dataField="name"
                                            dataFormat={(cell, row, enumObj, index) => this.nameFormatter(cell, row, enumObj, index, template)}
                                        >
                                            Name
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            className='align-center'
                                            columnClassName='align-center'
                                            dataField="address_1"
                                            dataFormat={(cell, row, enumObj, siteIndex) => this.addressFormatter(cell, row, enumObj, siteIndex, template, column, index)}
                                        >
                                            Address
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            className='align-center'
                                            columnClassName='align-center'
                                            dataField="city"
                                            dataFormat={(cell, row, enumObj, siteIndex) => this.cityFormatter(cell, row, enumObj, siteIndex, template, column, index)}
                                        >
                                            City
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            className='align-center'
                                            columnClassName='align-center'
                                            dataField="state"
                                            dataFormat={(cell, row, enumObj, siteIndex) => this.stateFormatter(cell, row, enumObj, siteIndex, template, column, index)}
                                        >
                                            State
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            className='align-center'
                                            columnClassName='align-center'
                                            dataField="zip"
                                            dataFormat={(cell, row, enumObj, siteIndex) => this.zipFormatter(cell, row, enumObj, siteIndex, template, column, index, user)}
                                        >
                                            Zip
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            className='align-center'
                                            columnClassName='align-center'
                                            dataField="country"
                                            dataFormat={(cell, row, enumObj, siteIndex) => this.countryFormatter(cell, row, enumObj, siteIndex, template, column, index)}
                                        >
                                            Country
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            className='align-center'
                                            columnClassName='align-center'
                                            dataField="site_sync"
                                            width="50"
                                            dataFormat={(cell, row, enumObj, siteIndex) => this.siteSyncFormatter(cell, row, enumObj, siteIndex, template, index, column)}
                                        >
                                            Sync
                                        </TableHeaderColumn>
                                    </BootstrapTable>
                                }
                            </Col>
                        </Row>
                    </Col> :
                    <Col md={isEditable ? 12 : 10}>
                        <Row>
                            <Col xs={4} className="text-left">
                                <p>Company Name: <span
                                    style={{color: template && user.company_name?.trim() === template.company_name?.trim() ? "green" : "red"}}>{user.company_name && user.company_name}</span>
                                </p>
                            </Col>
                            <Col xs={4} className="text-left">
                                {column === 'left' ?
                                    <OverlayTrigger
                                        placement='bottom'
                                        overlay={
                                            <Tooltip id='tooltip-customer-info'>
                                                Show customer
                                            </Tooltip>
                                        }
                                    >
                                        <p>Name:
                                            <Link target="_blank" to={`/customer/info/${user?.id}`} style={{
                                                color: template && user.first_name?.trim() === template.first_name?.trim() && user.last_name?.trim()
                                                === template.last_name?.trim() ? "green" : "red"
                                            }}>
                                            <span style={{
                                                color: template && user.first_name?.trim() === template.first_name?.trim() && user.last_name?.trim()
                                                === template.last_name?.trim() ? "green" : "red"
                                            }}> {user.first_name && user.first_name} {user.last_name && user.last_name}</span>
                                            </Link>
                                        </p>
                                    </OverlayTrigger>
                                    :
                                    <p>Name: <span style={{
                                        color: template && user.first_name?.trim() === template.first_name?.trim() && user.last_name?.trim()
                                        === template.last_name?.trim() ? "green" : "red"
                                    }}>{user.first_name && user.first_name} {user.last_name && user.last_name}</span>
                                    </p>
                                }
                            </Col>
                            <Col xs={4} className="text-left">
                                <p>Email: <span
                                    style={{
                                        color: template && isEmailMatch ? "green" : "red",
                                        wordBreak: "break-all"
                                    }}>{user.email_address && user.email_address}</span>
                                </p>
                            </Col>
                        </Row>
                    </Col>
                }
                {!isEditable && <Col md={1}>
                    <div onClick={() => {
                        let rows = this.state.collapsedRows
                        if (rows.includes(index)) {
                            rows = rows.filter(r => r !== index)
                        } else {
                            rows.push(index)
                        }
                        this.setState({collapsedRows: rows})
                    }}>
                        {this.state.collapsedRows.includes(index) ? <FontAwesomeIcon
                            className={`pointer`}
                            size='2x'
                            icon={faAngleUp}/> : <FontAwesomeIcon
                            className={`pointer`}
                            size='2x'
                            icon={faAngleDown}/>}
                    </div>
                </Col>}
                {!isEditable && column === 'right' &&
                    <Col md={1}
                         className={`text-right ${column === 'right' ? 'flex-column-end' : 'flex-column-start'}`}>
                        {user && template && user.quickbooks_id !== template.quickbooks_id && <FontAwesomeIcon
                            className="pointer"
                            icon={faTimesCircle}
                            size="1x"
                            data-toggle={'tooltip'}
                            title={'Delete match'}
                            onClick={() => {
                                const {content} = this.state
                                if (content[index]) {
                                    content[index].qb = null;
                                    this.setState(content);
                                }
                            }}/>}
                        <FontAwesomeIcon
                            className={`pointer mt-3 ${isRefreshing ? 'refresh-customer-active' : ''}`}
                            icon={faSync}
                            size="1x"
                            data-toggle={'tooltip'}
                            title={'Refresh customer'}
                            onClick={() => {
                                const {content} = this.state

                                if (!refreshingCustomerId) {
                                    if (column === 'right') {
                                        if (user?.quickbooks_id) {
                                            this.setState({refreshingCustomerId: user.quickbooks_id})
                                            this.refreshCustomerRow(index, content[index], {
                                                side: 'qb',
                                                onComplete: () => this.setState({refreshingCustomerId: null})
                                            })
                                        }
                                    } else {
                                        this.setState({refreshingCustomerId: user.id})
                                        this.refreshCustomerRow(index, content[index], {
                                            side: 'th',
                                            onComplete: () => this.setState({refreshingCustomerId: null})
                                        })
                                    }
                                }
                            }}/>
                    </Col>
                }
            </Row>
        )
    }

    customerFormatter = (cell, row, enumObject, index, direction = null) => {
        if (direction === 'right') {
            return (cell && !cell.isAssigned) ? this.userDataField(cell, row.th, direction, index) : this.searchQbUser(index)
        } else if (direction === 'left') {
            return (cell && !cell.isAssigned) ? this.userDataField(cell, row.qb, direction, index) : this.searchUser(index, cell)
        }
    }

    choiceFormatter = (cell, row, enumObject, index) => {
        const {rowLoading, addressSyncMap} = this.state;
        const items = row;

        if (items.qb && items.qb.sites) {
            items.qb.sites = items.qb.sites.map((site, siteIndex) => {
                const syncValue = addressSyncMap?.[index]?.[siteIndex]?.s_address_sync;

                const updatedSite = {
                    ...site,
                    s_address_sync: syncValue
                };

                if (items.th?.sites?.[siteIndex]) {
                    items.th.sites[siteIndex] = {
                        ...items.th.sites[siteIndex],
                        s_address_sync: syncValue
                    };
                }

                return updatedSite;
            });
        }


        return (
            rowLoading !== null && rowLoading === index ? <div><MDSpinner/></div> :
                <div>
                    {items.qb &&
                        <div>
                            <FontAwesomeIcon className="pointer"
                                             icon={faLongArrowAltLeft}
                                             size="2x"
                                             onClick={() => {
                                                 this.setState({rowLoading: index}, () => {
                                                     this.props.actions.updateCustomer(items, 'left',
                                                         (res) => {
                                                             this.handleCustomerSyncResult(res, index, items,
                                                                 () => this.syncCustomer(items.qb.quickbooks_id, index, false)
                                                             )
                                                         },
                                                         (res) => {
                                                             this.handleCustomerSyncResult(res, index, items,
                                                                 () => this.syncCustomer(items.qb.quickbooks_id, index, false)
                                                             )
                                                         }
                                                     )
                                                 })
                                             }}/>
                        </div>}

                    {items.th && <div>
                        <FontAwesomeIcon className="pointer"
                                         icon={faLongArrowAltRight}
                                         size="2x"
                                         onClick={() => {
                                             this.setState({rowLoading: index}, () => {
                                                 this.props.actions.updateCustomer(items, 'right',
                                                         (res) => {
                                                         if (res?.matched_customers) {
                                                             this.setState({
                                                                 matchedCustomerModal: {
                                                                     show: true,
                                                                     matched_customers: res?.matched_customers,
                                                                     index: index
                                                                 }
                                                             })
                                                         }
                                                         this.handleCustomerSyncResult(res, index, items,
                                                             () => this.syncCustomer(items.th.id, index, true)
                                                         )
                                                     },
                                                     (res) => {
                                                         this.handleCustomerSyncResult(res, index, items,
                                                             () => this.syncCustomer(items.th.id, index, true),
                                                             {refreshAfterHandledError: false}
                                                         )
                                                     }
                                                 )
                                             })
                                         }}/>
                    </div>}
                    {items.qb && items.th && items.qb.quickbooks_id === items.th.quickbooks_id && <div>
                        <FontAwesomeIcon className="pointer"
                                         icon={faTimes}
                                         size="2x"
                                         data-toggle={'tooltip'}
                                         title={'Disassociate an account'}
                                         onClick={() => this.setState({
                                             showDisassociateModal: {
                                                 show: true,
                                                 th_id: items?.th?.id,
                                                 index: index
                                             }
                                         })}
                        />
                    </div>}
                </div>
        )
    }


    render() {
        const {
            syncAllModal,
            resource,
            content,
            total,
            showDisassociateModal,
            errorModal,
            matchedCustomerModal,
            addressMismatchModal,
            tableResizeKey
        } = this.state;
        const {isLoading} = this.props;
        const {page, per_page} = this.state.resource;
        return (
            <Grid fluid>
                <Row className='reset-bottom-padding'>
                    <Col md={4}>
                        <Button
                            bsSize={'sm'}
                            bsStyle={'link'}
                            onClick={() => this.syncAllOnThisPage()}
                        >
                            Synchronize listed customers
                        </Button>
                    </Col>
                </Row>
                <Row className='reset-bottom-padding'>
                    <Col md={4} className='total'>
                        <b>Total Customers:</b> {total}
                    </Col>
                </Row>
                <Row>
                    {syncAllModal &&
                        <SyncAllModal
                            createImport={this.props.actions.createImport}
                            checkProgress={this.props.actions.checkProgress}
                            getTotalNumber={this.props.actions.getTotalNumber}
                            from={resource.from}
                            to={resource.to}
                            byInvoice={resource.byInvoice}
                            shippingAddressSync={resource.shippingAddressSync}
                            reload={this.sync}
                            synchronizeManyRecords={this.props.actions.synchronizeManyRecords}
                            acceptAddressMismatch={this.props.actions.acceptAddressMismatch}
                            previewAddressMismatches={this.props.actions.previewAddressMismatches}
                            showNotSyncCustomer={resource.showNotSyncCustomer}
                            showSynchronized={resource.showSynchronized}
                            show={syncAllModal}
                            synchronizeSelectedCustomer={this.props.actions.synchronizeSelectedCustomer}
                            synchronizeCustomer={(site_id, quickbooks_id, customer_quickbooks_id) => {
                                const index = 0
                                this.props.actions.syncCustomersSite({
                                        site_id: site_id,
                                        quickbooks_id: quickbooks_id,
                                        customer_quickbooks_id: customer_quickbooks_id,
                                        s_address_sync: false
                                    },
                                    () => {
                                        this.refreshCustomerRow(index, content[index], {
                                            thId: template?.id || template?.customer?.id,
                                            qbId: template?.quickbooks_id || template?.customer?.quickbooks_id,
                                            onComplete: () => this.setState({rowLoading: null})
                                        })
                                    },
                                    (res) => {
                                        if (!this.handleQuickbooksError(res, index, content[index])) {
                                            this.setState({rowLoading: null})
                                        }
                                    }
                                )
                            }}
                            onHide={() => this.syncAllOnThisPage()}
                            category={'customers'}
                            page={resource.page}
                            perPage={resource.per_page}
                        />}
                    {showDisassociateModal?.show &&
                        <ConfirmDisassociateModal
                            type="customer"
                            onHide={() => this.setState({
                                showDisassociateModal: {
                                    show: false,
                                    th_id: null,
                                    index: null
                                }
                            })}
                            onSave={() => {
                                this.props.actions.disassociateAccount(showDisassociateModal?.th_id, () => {
                                    const {content} = this.state
                                    if (content[showDisassociateModal?.index]) {
                                        let rowCustomers = content[showDisassociateModal?.index]
                                        rowCustomers.qb = null;
                                        this.setState({content}, () => {
                                            this.refreshCustomerRow(showDisassociateModal.index, rowCustomers, {side: 'th'})
                                        });
                                    }
                                })
                            }}
                        />
                    }
                    {errorModal?.show &&
                        <ErrorInfoModal
                            type="Customer"
                            message={errorModal?.message}
                            errorSites={errorModal?.error_sites}
                            onHide={() => {
                                const errorModal = {
                                    show: false,
                                    error_sites: [],
                                    message: ''
                                }
                                this.setState({errorModal})
                            }}
                        />
                    }
                    {addressMismatchModal?.show &&
                        <AddressMismatchModal
                            mismatches={addressMismatchModal?.mismatches}
                            isSaving={addressMismatchModal.isSaving}
                            savingMismatchKey={addressMismatchModal.savingMismatchKey}
                            onAccept={this.acceptAddressMismatch}
                            onHide={() => this.setState({
                                addressMismatchModal: {show: false, mismatches: [], index: null, items: null, isSaving: false, savingMismatchKey: null}
                            })}
                        />
                    }
                    {matchedCustomerModal?.show &&
                        <MatchedCustomersModal
                            matchedCustomers={matchedCustomerModal.matched_customers}
                            onHide={() => {
                                const matchedCustomerModal = {
                                    show: false,
                                    matched_customers: null
                                }
                                this.setState({matchedCustomerModal})
                            }}
                            syncMany={false}
                            reload={(QBCustomer) => {
                                const rowCustomer = content[matchedCustomerModal?.index]
                                if (rowCustomer) {
                                    rowCustomer.qb = QBCustomer;
                                    content[matchedCustomerModal?.index] = rowCustomer;
                                    this.setState({content}, () => {
                                        this.refreshCustomerRow(matchedCustomerModal.index, rowCustomer, {
                                            side: 'th',
                                            onComplete: () => this.setState({rowLoading: null})
                                        })
                                    });
                                } else {
                                    this.setState({rowLoading: null})
                                }
                            }}
                            onSync={this.props.actions.synchronizeSelectedCustomer}
                        />
                    }
                    <Col xs={12} className={`top25 no-padding`}>
                        <BootstrapTable
                            ref="table"
                            key={`${page}-${tableResizeKey}`}
                            data={content}
                            striped={false}
                            bordered
                            hover={true}
                            pagination={true}
                            remote
                            fetchInfo={{dataTotalSize: total}}
                            className={classNames('wrapped', {'quickbooks-pagination-disabled': isLoading})}
                            trClassName={this.rowSynchronizedClass}
                            options={
                                {
                                    onPageChange: (page, per_page) => {
                                        if (isLoading) {
                                            return;
                                        }
                                        let {resource} = this.state;
                                        let perPage = per_page
                                        if (!per_page) {
                                            perPage = 'All'
                                        }
                                        resource = {...resource, page, per_page: perPage};
                                        this.props.setIsLoading && this.props.setIsLoading();
                                        this.setState({resource}, this.sync);
                                    },
                                    page,
                                    sizePerPageList: [{
                                        text: '10', value: 10
                                    }, {
                                        text: '25', value: 25
                                    },
                                        {
                                            text: '30', value: 30
                                        },
                                        {
                                            text: '50', value: 50
                                        },
                                        {
                                            text: '100', value: 100
                                        },
                                        {
                                            text: '200', value: 200
                                        },
                                        {
                                            text: 'All', value: null
                                    }],
                                    sizePerPage: per_page === 'All' ? total || 1 : per_page,
                                    hidePageListOnlyOnePage: true,
                                    sizePerPageDropDown: this.renderSizePerPageDropDown,
                                }
                            }
                            selectRow={{
                                mode: "hidden",
                                clickToSelect: false,
                                onSelect: this.onRowSelect,
                                onSelectAll: this.onSelectAll,
                            }}
                        >
                            <TableHeaderColumn
                                dataField="id"
                                hidden
                                width={"5%"}
                                isKey
                            />
                            <TableHeaderColumn
                                className='align-center'
                                columnClassName='align-center'
                                width={"45%"}
                                dataField="th"
                                dataFormat={(cell, row, enumObj, index) => this.customerFormatter(cell, row, enumObj, index, 'left')}
                            >
                                TreeHub Customers
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                width={"10%"}
                                className='align-center'
                                columnClassName='align-center'
                                dataFormat={this.choiceFormatter}
                            >
                                Choice
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                className='align-center'
                                columnClassName='align-center'
                                dataField="qb"
                                dataFormat={(cell, row, enumObj, index) => this.customerFormatter(cell, row, enumObj, index, 'right')}
                                width={"45%"}
                            >
                                QuickBooks Customers
                            </TableHeaderColumn>
                        </BootstrapTable>
                    </Col>
                </Row>
            </Grid>
        );
    }


}

QuickbooksCustomers.propTypes = {
    //myProp: PropTypes.object.isRequired
};

QuickbooksCustomers.defaultProps = {
    //myProp: <defaultValue>
};

function mapStateToProps(state, ownProps) {
    return {
        clientId: state.auth.client_id
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(QuickbooksCustomers);
